var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"progress rounded-0 bg-light-primary shadow-sm",style:(`height: ${_vm.height};`)},[_c('div',{staticClass:"progress-bar",class:{'bg-success': _vm.at === _vm.total},style:(`width: ${_vm.percent}%;`),attrs:{"role":"progressbar","aria-valuenow":_vm.at,"aria-valuemax":_vm.total,"aria-valuemin":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }